"use client"

import { convertToLocale } from "@/lib/helpers/money"

export const CartSummary = ({
  item_total,
  shipping_total,
  total,
  currency_code,
  tax,
  discount_total,
  shipping_chosen = true,
}: {
  item_total: number
  shipping_total: number
  total: number
  currency_code: string
  tax: number
  discount_total: number
  /** السلة بلا طريقة توصيل بعد: التوصيل «يُحدَّد…» لا 0، والإجمالي بلا توصيل */
  shipping_chosen?: boolean
}) => {
  return (
    <div data-testid="cart-summary">
      <div className="space-y-4 label-md text-secondary mb-4">
        <div className="flex justify-between" data-testid="cart-summary-items">
          <span>القطع:</span>
          <span className="text-primary">
            {convertToLocale({
              amount: item_total,
              currency_code,
            })}
          </span>
        </div>
        <div className="flex justify-between" data-testid="cart-summary-delivery">
          <span>التوصيل:</span>
          <span className="text-primary">
            {shipping_chosen
              ? convertToLocale({
                  amount: shipping_total,
                  currency_code,
                })
              : "يُحدَّد عند اختيار التوصيل"}
          </span>
        </div>
        {/* لا ضريبة في ليبيا الآن: السطر يظهر فقط إن وُجدت ضريبة فعلاً */}
        {tax > 0 && (
          <div className="flex justify-between" data-testid="cart-summary-tax">
            <span>الضريبة:</span>
            <span className="text-primary">
              {convertToLocale({
                amount: tax,
                currency_code,
              })}
            </span>
          </div>
        )}
        <div className="flex justify-between" data-testid="cart-summary-discount">
          <span>الخصم:</span>
          <span className="text-primary">
            {convertToLocale({
              amount: discount_total,
              currency_code,
            })}
          </span>
        </div>
        <div className="flex justify-between border-t pt-4 items-center" data-testid="cart-summary-total">
          <span>الإجمالي:</span>
          <span className="label-xl text-primary">
            {convertToLocale({
              amount: total,
              currency_code,
            })}
          </span>
        </div>
        {!shipping_chosen && (
          <p className="label-sm text-secondary" data-testid="cart-summary-no-delivery">
            الإجمالي لا يشمل التوصيل بعد. تختاره في الخطوة التالية — ولطلب من أكثر من بائع يمكنك اختيار شحنة واحدة مجمّعة برسوم أقل.
          </p>
        )}
      </div>
    </div>
  )
}
